export default "__VITE_ASSET__BdgCdEeM__"